import { createFileRoute, notFound } from '@tanstack/react-router';
import { getPost, loadPostBody } from '@content/blog';
import { cmsHead } from '@lib/cmsHead';
import { BlogPostPage } from '@templates/BlogPostPage';

export const Route = createFileRoute('/blog/$slug')({
  loader: async ({ params }) => {
    const post = getPost(params.slug);
    if (!post) throw notFound();
    return { post, body: await loadPostBody(post.slug) };
  },
  head: ({ loaderData }) =>
    loaderData
      ? cmsHead(loaderData.post.seo, `/blog/${loaderData.post.slug}`, [
          // Relative, as Webflow emitted it: resolves to /blog/rss.xml.
          { href: 'rss.xml', rel: 'alternate', title: 'RSS Feed', type: 'application/rss+xml' },
        ])
      : {},
  component: BlogPostRoute,
});

function BlogPostRoute() {
  const { post, body } = Route.useLoaderData();
  return <BlogPostPage post={post} body={body} />;
}
